import { render, staticRenderFns } from "./RegionalIcon.vue?vue&type=template&id=6e2f9816&scoped=true&"
import script from "./RegionalIcon.vue?vue&type=script&lang=js&"
export * from "./RegionalIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2f9816",
  null
  
)

export default component.exports